<template>
    <v-container fluid class="fill-height pa-0" width="100%">
        <v-card color="white" width="100%">
            <v-toolbar color="amber">
                <v-btn icon @click="Close"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black" v-if="edit == true">Edit Location</v-toolbar-title>
                 <v-toolbar-title class="font-weight-black" v-else>New Location</v-toolbar-title>
                    <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-switch v-model="isDefaultHere" :label="isDefaultHere == true ? 'Set Default': 'Not Default'" :value="true" color="black" class="mr-5 mt-5"></v-switch>
                    <v-switch v-model="statusHere" :label="statusHere == true ? 'Active': 'In Active'" :value="true" color="black" class="mr-5 mt-5"></v-switch>
                    <v-btn color="black" class="amber--text" @click="save()" :loading="isLoading">Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-form class="pa-5">
                    <v-row dense>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="location" outlined label="Location"  color="amber"></v-text-field>
                        </v-col>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="freight" label="Freight" outlined color="amber"></v-text-field>
                        </v-col>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="loadingCarges" label="Loading Carges" outlined color="amber"></v-text-field>
                        </v-col>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="interest" label="Interest" outlined color="amber"></v-text-field>
                        </v-col>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="other" label="Others" outlined color="amber"></v-text-field>
                        </v-col>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="gst" label="GST" outlined color="amber"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
        <span style="display:none;">{{checkfetch}}</span>
    </v-container>
</template>

<script>
import { SERVER_API } from "../../API/";
export default {
    created(){
        window.addEventListener('keyup', event => {
            if(event.which === 27){
                this.Close();
            }
            if(event.which === 13){
                this.Save();
            }
        })
    },
    props:['id','edit'],
    data(){
        return{
            location:'',
            freight:'',
            gst:'',
            loadingCarges:'',
            interest:'',
            other:'',
            isDefault:'',
            status:0,
            statusHere:false,
            isDefaultHere:false,
            productData:[],
            isLoading:false,
        }
    },
    watch:{
        statusHere(val){
            if(val == true){
                this.status = 1;
            }else{
                this.status = 0;
            }
        },
        isDefaultHere(val){
            if(val == true){
                this.isDefault = 1;
            }else{
                this.isDefault = 0;
            }
        }
    },
    computed:{
        checkfetch(){
            return this.fetchById();
        }
    },
    methods:{
         reset(){
            this.location = ''
            this.freight = ''
            this.gst = ''
            this.loadingCarges = ''
            this.interest = ''
            this.other = ''
            this.isDefaultHere = false
            this.isDefault = 0
        },
        Close(){
            this.reset();
            this.$emit('Close',false);
        },
        async fetchById(){
            if(this.edit == true){
                const response = await this.$http.get(SERVER_API+'/location/byid/'+this.id);
                this.location = response.data.data.location;
                this.freight = response.data.data.freight;
                this.gst = response.data.data.gst;
                this.loadingCarges = response.data.data.loadingCarges;
                this.interest = response.data.data.interest;
                this.other = response.data.data.other;
                this.isDefault = response.data.data.isDefault;
                this.isDefaultHere = response.data.data.isDefault == 0 ? false : true;
                this.status = response.data.data.status;    
                this.statusHere = response.data.data.status == 0 ? false : true;
            }
        },
        async save(){
            if(this.edit == true){
                try{
                    this.isLoading = true;
                    const response = await this.$http.put(SERVER_API+'/location/update',{
                        id:this.id,
                        location: this.location,
                        status: this.status,
                        freight: this.freight,
                        gst: this.gst,
                        loadingCarges: this.loadingCarges,
                        interest: this.interest,
                        other: this.other,
                        isDefault: this.isDefault,
                    });
                    this.isLoading = false;
                    this.$emit('Response',response.data);
                }catch(error){
                    this.$emit('Response',error);
                    this.isLoading = false;
                }
            }else{
                try{
                    this.isLoading = true;
                    const response = await this.$http.post(SERVER_API+'/location/create',{
                        location: this.location,
                        status: this.status,
                        freight: this.freight,
                        gst: this.gst,
                        loadingCarges: this.loadingCarges,
                        interest: this.interest,
                        other: this.other,
                        isDefault: this.isDefault,
                    });
                    this.reset()
                    this.isLoading = false;
                    this.$emit('Response',response.data);
                }catch(error){
                    this.$emit('Response',error);
                    this.isLoading = false;
                }
            }
        }
    }

}
</script>

<style>

</style>